// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__3d3P1","title":"Images90_title__Bxm_E","images":"Images90_images__3vxhR"};